import {
  ServerMessageType,
  type ServerChatMessage,
  type AttackResultMessage,
  type MeleeSwingMessage,
  type AoeTelegraphMessage,
  type NpcTemplateListMessage,
  type NpcDialogueMessage,
  type GroundItemsSyncMessage,
  type ItemTemplateListMessage,
  type InventorySyncMessage,
  type PlayAnimationMessage,
  type CharacterStatsMessage,
  type TileInfoMessage,
  type SkillTreeSyncMessage,
  type SkillNodeAllocatedMessage,
  type SkillTreeResetMessage,
  type SpellCastResultMessage,
  type SpellLearnedMessage,
  type SpellBarSyncMessage,
  type LearnedSpellsSyncMessage,
  type AuraToggledMessage,
  type SummonModeChangedMessage,
  type CastStartedMessage,
  type CastInterruptedMessage,
  type BoatChannelStartedMessage,
  type BoatChannelInterruptedMessage,
  type SpellWordsMessage,
  type MeditateStateMessage,
  type SpawnProtectionStateMessage,
  type LevelUpMessage,
  type ExpGainedMessage,
  type SkillsSyncMessage,
  type SkillXpGainedMessage,
  type SkillLevelUpMessage,
  type SkillNoticeMessage,
  type WorkStartedMessage,
  type WorkStoppedMessage,
  type MerchantOpenedMessage,
  type SpellVendorOpenedMessage,
  type GoldUpdatedMessage,
  type NpcRespawnedMessage,
  type ActiveBuffsSyncMessage,
  type MovementConfirmedMessage,
  type PlayerTeleportedMessage,
  type PlayerMapChangeMessage,
  type PlayEntityFxMessage,
  type PlaySoundMessage,
  type AreaEnteredMessage,
  type AreaEntryDeniedMessage,
  type FactionStatsMessage,
  type FactionJoinPromptMessage,
  type FactionRankInfoMessage,
  type FactionBroadcastMessage,
  type QuestLogSyncMessage,
  type QuestOfferMessage,
  type QuestProgressMessage,
  type QuestCompletedMessage,
  type ExchangeOpenedMessage,
  type ExchangeBookMessage,
  type ExchangeClaimsMessage,
  type MarketplaceOpenedMessage,
  type MarketplaceResultsMessage,
  type MarketplaceAppraisalMessage,
  type MarketplaceSavedSearchesMessage,
  type ExchangeWatchesMessage,
  type MarketAlertsMessage,
  type TraderStatsMessage,
  type PartySyncMessage,
  type PartyInviteReceivedMessage,
  type PartyFinderResultsMessage,
  type PartyNotifyMessage,
} from '@shared/types/messages';
import { ColyseusClient } from './ColyseusClient';

export interface ServerMessageHandlers {
  onChatMessage?: (message: ServerChatMessage) => void;
  onAttackResult?: (message: AttackResultMessage) => void;
  onMeleeSwing?: (message: MeleeSwingMessage) => void;
  onAoeTelegraph?: (message: AoeTelegraphMessage) => void;
  onNpcTemplateList?: (message: NpcTemplateListMessage) => void;
  onNpcDialogue?: (message: NpcDialogueMessage) => void;
  onGroundItemsSync?: (message: GroundItemsSyncMessage) => void;
  onItemTemplateList?: (message: ItemTemplateListMessage) => void;
  onInventorySync?: (message: InventorySyncMessage) => void;
  onPlayAnimation?: (message: PlayAnimationMessage) => void;
  onCharacterStats?: (message: CharacterStatsMessage) => void;
  onTileInfo?: (message: TileInfoMessage) => void;
  // Skill Tree (Espíritu)
  onSkillTreeSync?: (message: SkillTreeSyncMessage) => void;
  onSkillNodeAllocated?: (message: SkillNodeAllocatedMessage) => void;
  onSkillTreeReset?: (message: SkillTreeResetMessage) => void;
  // Skills de progresión (Minería/Herrería/…)
  onSkillsSync?: (message: SkillsSyncMessage) => void;
  onSkillXpGained?: (message: SkillXpGainedMessage) => void;
  onSkillLevelUp?: (message: SkillLevelUpMessage) => void;
  onSkillNotice?: (message: SkillNoticeMessage) => void;
  // Modo trabajo (auto-extracción). Ver docs/FISHING_SKILL.md.
  onWorkStarted?: (message: WorkStartedMessage) => void;
  onWorkStopped?: (message: WorkStoppedMessage) => void;
  // Spell System
  onSpellCastResult?: (message: SpellCastResultMessage) => void;
  onSpellLearned?: (message: SpellLearnedMessage) => void;
  onSpellBarSync?: (message: SpellBarSyncMessage) => void;
  onLearnedSpellsSync?: (message: LearnedSpellsSyncMessage) => void;
  onAuraToggled?: (message: AuraToggledMessage) => void;
  onSummonModeChanged?: (message: SummonModeChangedMessage) => void;
  onCastStarted?: (message: CastStartedMessage) => void;
  onCastInterrupted?: (message: CastInterruptedMessage) => void;
  onBoatChannelStarted?: (message: BoatChannelStartedMessage) => void;
  onBoatChannelInterrupted?: (message: BoatChannelInterruptedMessage) => void;
  onSpellWords?: (message: SpellWordsMessage) => void;
  onMeditateState?: (message: MeditateStateMessage) => void;
  onSpawnProtectionState?: (message: SpawnProtectionStateMessage) => void;
  onLevelUp?: (message: LevelUpMessage) => void;
  onExpGained?: (message: ExpGainedMessage) => void;
  onMerchantOpened?: (message: MerchantOpenedMessage) => void;
  onSpellVendorOpened?: (message: SpellVendorOpenedMessage) => void;
  onGoldUpdated?: (message: GoldUpdatedMessage) => void;
  onNpcRespawned?: (message: NpcRespawnedMessage) => void;
  onActiveBuffsSync?: (message: ActiveBuffsSyncMessage) => void;
  onMovementConfirmed?: (message: MovementConfirmedMessage) => void;
  onPlayerTeleported?: (message: PlayerTeleportedMessage) => void;
  onPlayerMapChange?: (message: PlayerMapChangeMessage) => void;
  onPlayEntityFx?: (message: PlayEntityFxMessage) => void;
  onPlaySound?: (message: PlaySoundMessage) => void;
  onAreaEntered?: (message: AreaEnteredMessage) => void;
  onAreaEntryDenied?: (message: AreaEntryDeniedMessage) => void;
  // Facciones (ver docs/FACTIONS.md)
  onFactionStats?: (message: FactionStatsMessage) => void;
  onFactionJoinPrompt?: (message: FactionJoinPromptMessage) => void;
  onFactionRankInfo?: (message: FactionRankInfoMessage) => void;
  onFactionBroadcast?: (message: FactionBroadcastMessage) => void;
  // Quests (ver docs/QUESTS.md)
  onQuestLogSync?: (message: QuestLogSyncMessage) => void;
  onQuestOffer?: (message: QuestOfferMessage) => void;
  onQuestProgress?: (message: QuestProgressMessage) => void;
  onQuestCompleted?: (message: QuestCompletedMessage) => void;
  // Economía — Exchange (ver docs/ECONOMY_EXCHANGE_MARKETPLACE.md)
  onExchangeOpened?: (message: ExchangeOpenedMessage) => void;
  onExchangeBook?: (message: ExchangeBookMessage) => void;
  onExchangeClaims?: (message: ExchangeClaimsMessage) => void;
  // Economía — Marketplace
  onMarketplaceOpened?: (message: MarketplaceOpenedMessage) => void;
  onMarketplaceResults?: (message: MarketplaceResultsMessage) => void;
  onMarketplaceAppraisal?: (message: MarketplaceAppraisalMessage) => void;
  // Economía — perfil de comerciante
  onMarketplaceSavedSearches?: (message: MarketplaceSavedSearchesMessage) => void;
  onExchangeWatches?: (message: ExchangeWatchesMessage) => void;
  onMarketAlerts?: (message: MarketAlertsMessage) => void;
  onTraderStats?: (message: TraderStatsMessage) => void;
  // Party (ver docs/PARTY_SYSTEM.md)
  onPartySync?: (message: PartySyncMessage) => void;
  onPartyInviteReceived?: (message: PartyInviteReceivedMessage) => void;
  onPartyFinderResults?: (message: PartyFinderResultsMessage) => void;
  onPartyNotify?: (message: PartyNotifyMessage) => void;
  onError?: (message: unknown) => void;
  onUnknown?: (message: unknown) => void;
}

/**
 * Encapsula el registro de handlers de mensajes del servidor.
 * Delega el switch de tipos y mantiene la escena más liviana.
 */
export const registerServerMessageHandlers = (
  client: ColyseusClient,
  handlers: ServerMessageHandlers
): void => {
  client.onServerMessage((message) => {
    switch (message.type) {
      case ServerMessageType.CHAT_MESSAGE:
        handlers.onChatMessage?.(message as ServerChatMessage);
        break;
      case ServerMessageType.ATTACK_RESULT:
        handlers.onAttackResult?.(message as AttackResultMessage);
        break;
      case ServerMessageType.AOE_TELEGRAPH:
        handlers.onAoeTelegraph?.(message as AoeTelegraphMessage);
        break;
      case ServerMessageType.MELEE_SWING:
        handlers.onMeleeSwing?.(message as MeleeSwingMessage);
        break;
      case ServerMessageType.NPC_TEMPLATE_LIST:
        handlers.onNpcTemplateList?.(message as NpcTemplateListMessage);
        break;
      case ServerMessageType.NPC_DIALOGUE:
        handlers.onNpcDialogue?.(message as NpcDialogueMessage);
        break;
      case ServerMessageType.GROUND_ITEMS_SYNC:
        handlers.onGroundItemsSync?.(message as GroundItemsSyncMessage);
        break;
      case ServerMessageType.ITEM_TEMPLATE_LIST:
        handlers.onItemTemplateList?.(message as ItemTemplateListMessage);
        break;
      case ServerMessageType.INVENTORY_SYNC:
        handlers.onInventorySync?.(message as InventorySyncMessage);
        break;
      case ServerMessageType.PLAY_ANIMATION:
        handlers.onPlayAnimation?.(message as PlayAnimationMessage);
        break;
      case ServerMessageType.CHARACTER_STATS:
        handlers.onCharacterStats?.(message as CharacterStatsMessage);
        break;
      case ServerMessageType.TILE_INFO:
        handlers.onTileInfo?.(message as TileInfoMessage);
        break;
      // Skill Tree (Espíritu)
      case ServerMessageType.SKILL_TREE_SYNC:
        handlers.onSkillTreeSync?.(message as SkillTreeSyncMessage);
        break;
      case ServerMessageType.SKILL_NODE_ALLOCATED:
        handlers.onSkillNodeAllocated?.(message as SkillNodeAllocatedMessage);
        break;
      case ServerMessageType.SKILL_TREE_RESET:
        handlers.onSkillTreeReset?.(message as SkillTreeResetMessage);
        break;
      // Spell System
      case ServerMessageType.SPELL_CAST_RESULT:
        handlers.onSpellCastResult?.(message as SpellCastResultMessage);
        break;
      case ServerMessageType.SPELL_LEARNED:
        handlers.onSpellLearned?.(message as SpellLearnedMessage);
        break;
      case ServerMessageType.SPELL_BAR_SYNC:
        handlers.onSpellBarSync?.(message as SpellBarSyncMessage);
        break;
      case ServerMessageType.LEARNED_SPELLS_SYNC:
        handlers.onLearnedSpellsSync?.(message as LearnedSpellsSyncMessage);
        break;
      case ServerMessageType.AURA_TOGGLED:
        handlers.onAuraToggled?.(message as AuraToggledMessage);
        break;
      case ServerMessageType.SUMMON_MODE_CHANGED:
        handlers.onSummonModeChanged?.(message as SummonModeChangedMessage);
        break;
      case ServerMessageType.CAST_STARTED:
        handlers.onCastStarted?.(message as CastStartedMessage);
        break;
      case ServerMessageType.CAST_INTERRUPTED:
        handlers.onCastInterrupted?.(message as CastInterruptedMessage);
        break;
      case ServerMessageType.BOAT_CHANNEL_STARTED:
        handlers.onBoatChannelStarted?.(message as BoatChannelStartedMessage);
        break;
      case ServerMessageType.BOAT_CHANNEL_INTERRUPTED:
        handlers.onBoatChannelInterrupted?.(message as BoatChannelInterruptedMessage);
        break;
      case ServerMessageType.SPELL_WORDS:
        handlers.onSpellWords?.(message as SpellWordsMessage);
        break;
      case ServerMessageType.SPAWN_PROTECTION_STATE:
        handlers.onSpawnProtectionState?.(message as SpawnProtectionStateMessage);
        break;
      case ServerMessageType.MEDITATE_STATE:
        handlers.onMeditateState?.(message as MeditateStateMessage);
        break;
      case ServerMessageType.LEVEL_UP:
        handlers.onLevelUp?.(message as LevelUpMessage);
        break;
      case ServerMessageType.SKILLS_SYNC:
        handlers.onSkillsSync?.(message as SkillsSyncMessage);
        break;
      case ServerMessageType.SKILL_XP_GAINED:
        handlers.onSkillXpGained?.(message as SkillXpGainedMessage);
        break;
      case ServerMessageType.SKILL_LEVEL_UP:
        handlers.onSkillLevelUp?.(message as SkillLevelUpMessage);
        break;
      case ServerMessageType.SKILL_NOTICE:
        handlers.onSkillNotice?.(message as SkillNoticeMessage);
        break;
      case ServerMessageType.WORK_STARTED:
        handlers.onWorkStarted?.(message as WorkStartedMessage);
        break;
      case ServerMessageType.WORK_STOPPED:
        handlers.onWorkStopped?.(message as WorkStoppedMessage);
        break;
      case ServerMessageType.EXP_GAINED:
        handlers.onExpGained?.(message as ExpGainedMessage);
        break;
      case ServerMessageType.MERCHANT_OPENED:
        handlers.onMerchantOpened?.(message as MerchantOpenedMessage);
        break;
      case ServerMessageType.SPELL_VENDOR_OPENED:
        handlers.onSpellVendorOpened?.(message as SpellVendorOpenedMessage);
        break;
      case ServerMessageType.GOLD_UPDATED:
        handlers.onGoldUpdated?.(message as GoldUpdatedMessage);
        break;
      case ServerMessageType.NPC_RESPAWNED:
        handlers.onNpcRespawned?.(message as NpcRespawnedMessage);
        break;
      case ServerMessageType.ACTIVE_BUFFS_SYNC:
        handlers.onActiveBuffsSync?.(message as ActiveBuffsSyncMessage);
        break;
      case ServerMessageType.MOVEMENT_CONFIRMED:
        handlers.onMovementConfirmed?.(message as MovementConfirmedMessage);
        break;
      case ServerMessageType.PLAYER_TELEPORTED:
        handlers.onPlayerTeleported?.(message as PlayerTeleportedMessage);
        break;
      case ServerMessageType.PLAYER_MAP_CHANGE:
        handlers.onPlayerMapChange?.(message as PlayerMapChangeMessage);
        break;
      case ServerMessageType.PLAY_ENTITY_FX:
        handlers.onPlayEntityFx?.(message as PlayEntityFxMessage);
        break;
      case ServerMessageType.PLAY_SOUND:
        handlers.onPlaySound?.(message as PlaySoundMessage);
        break;
      case ServerMessageType.AREA_ENTERED:
        handlers.onAreaEntered?.(message as AreaEnteredMessage);
        break;
      case ServerMessageType.AREA_ENTRY_DENIED:
        handlers.onAreaEntryDenied?.(message as AreaEntryDeniedMessage);
        break;
      case ServerMessageType.FACTION_STATS:
        handlers.onFactionStats?.(message as FactionStatsMessage);
        break;
      case ServerMessageType.FACTION_JOIN_PROMPT:
        handlers.onFactionJoinPrompt?.(message as FactionJoinPromptMessage);
        break;
      case ServerMessageType.FACTION_RANK_INFO:
        handlers.onFactionRankInfo?.(message as FactionRankInfoMessage);
        break;
      case ServerMessageType.FACTION_BROADCAST:
        handlers.onFactionBroadcast?.(message as FactionBroadcastMessage);
        break;
      case ServerMessageType.QUEST_LOG_SYNC:
        handlers.onQuestLogSync?.(message as QuestLogSyncMessage);
        break;
      case ServerMessageType.QUEST_OFFER:
        handlers.onQuestOffer?.(message as QuestOfferMessage);
        break;
      case ServerMessageType.QUEST_PROGRESS:
        handlers.onQuestProgress?.(message as QuestProgressMessage);
        break;
      case ServerMessageType.QUEST_COMPLETED:
        handlers.onQuestCompleted?.(message as QuestCompletedMessage);
        break;
      case ServerMessageType.EXCHANGE_OPENED:
        handlers.onExchangeOpened?.(message as ExchangeOpenedMessage);
        break;
      case ServerMessageType.EXCHANGE_BOOK:
        handlers.onExchangeBook?.(message as ExchangeBookMessage);
        break;
      case ServerMessageType.EXCHANGE_CLAIMS:
        handlers.onExchangeClaims?.(message as ExchangeClaimsMessage);
        break;
      case ServerMessageType.MARKETPLACE_OPENED:
        handlers.onMarketplaceOpened?.(message as MarketplaceOpenedMessage);
        break;
      case ServerMessageType.MARKETPLACE_RESULTS:
        handlers.onMarketplaceResults?.(message as MarketplaceResultsMessage);
        break;
      case ServerMessageType.MARKETPLACE_APPRAISAL:
        handlers.onMarketplaceAppraisal?.(message as MarketplaceAppraisalMessage);
        break;
      case ServerMessageType.MARKETPLACE_SAVED_SEARCHES:
        handlers.onMarketplaceSavedSearches?.(message as MarketplaceSavedSearchesMessage);
        break;
      case ServerMessageType.EXCHANGE_WATCHES:
        handlers.onExchangeWatches?.(message as ExchangeWatchesMessage);
        break;
      case ServerMessageType.MARKET_ALERTS:
        handlers.onMarketAlerts?.(message as MarketAlertsMessage);
        break;
      case ServerMessageType.TRADER_STATS:
        handlers.onTraderStats?.(message as TraderStatsMessage);
        break;
      case ServerMessageType.PARTY_SYNC:
        handlers.onPartySync?.(message as PartySyncMessage);
        break;
      case ServerMessageType.PARTY_INVITE_RECEIVED:
        handlers.onPartyInviteReceived?.(message as PartyInviteReceivedMessage);
        break;
      case ServerMessageType.PARTY_FINDER_RESULTS:
        handlers.onPartyFinderResults?.(message as PartyFinderResultsMessage);
        break;
      case ServerMessageType.PARTY_NOTIFY:
        handlers.onPartyNotify?.(message as PartyNotifyMessage);
        break;
      case ServerMessageType.ERROR:
        handlers.onError?.(message);
        break;
      default:
        handlers.onUnknown?.(message);
        break;
    }
  });
};

